<script setup lang="ts">
import { computed } from "vue";
import type { Category } from "./shared";
import { CATEGORIES_IMAGES } from "./shared";

const props = defineProps<{
    category: Category;
}>();

const image = computed(() => {
    const normalizedName = props.category.name.toLowerCase().replace(/ /g, "-");
    return (
        CATEGORIES_IMAGES[normalizedName as keyof typeof CATEGORIES_IMAGES] ||
        null
    );
});
</script>

<template>
    <a
        :href="`/search?category_id=${category.id}`"
        class="w-full flex flex-col gap-4 border border-categories-border rounded-2xl p-4"
    >
        <h3 class="text-24 font-bold font-mulish leading-140 text-custom-black">
            {{ category.name }}
        </h3>
        <div
            v-if="category.children?.length"
            class="w-full flex flex-wrap gap-2"
        >
            <p
                v-for="child in category.children"
                :key="child.id"
                class="px-1.5 border rounded-4 font-mulish text-12 leading-5 font-light text-custom-blue border-graphite-2"
            >
                {{ child.name }}
            </p>
        </div>
        <div
            v-if="image"
            class="w-full aspect-video mt-auto rounded-lg overflow-hidden"
        >
            <img
                :src="image"
                :alt="category.name"
                loading="lazy"
                class="w-full h-full object-cover"
            />
        </div>
    </a>
</template>
